import { useResi3DStore } from "@common/features/Residences3D/state/resi3DStore"
import { useFavoritesStore } from "@state/favouritesStore"
import styled from "styled-components/macro"
import React, { useCallback } from "react"
import { HeartFilledIcon, HeartIcon } from "@radix-ui/react-icons"
import { poundFormatter } from "@utils/functions"

const TableRow = ({
  cells,
  row,
  rowIndex,
  isSelected,
  onClick,
  columns,
  onPointerOver,
  onPointerOut,
}: any) => {
  const hoveredUnit = useResi3DStore((s) => s.hoveredUnit)
  const hovered = hoveredUnit[0] === row.unitName
  const { addToFavorites, isFavorite } = useFavoritesStore()

  const handleClick = useCallback(() => {
    if (onClick) onClick()
  }, [onClick])

  const handlePointerOver = useCallback(() => {
    if (onPointerOver) onPointerOver()
  }, [onPointerOver])

  const handlePointerOut = useCallback(() => {
    if (onPointerOut) onPointerOut()
  }, [onPointerOut])

  return (
    <TableRowContainer
      hovered={hovered}
      onPointerOver={handlePointerOver}
      onPointerOut={handlePointerOut}
      className={`grid-table-row ${isSelected ? "selected" : ""}`}
      onClick={handleClick}
      columns={columns}
      id={row["unitName"]}
    >
      {cells.map((cell, index) => (
        <TableCell key={index}>
          {typeof cell === "object" && cell?.render !== undefined
            ? cell.render(row, rowIndex)
            : processCell(row, cell)}
        </TableCell>
      ))}
      <TableCell
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          addToFavorites(row)
        }}
      >
        {isFavorite(row) ? <HeartFilledIcon /> : <HeartIcon />}
      </TableCell>
    </TableRowContainer>
  )
}

export { TableRow }

const TableRowContainer = styled.div<{ columns: number; hovered: boolean }>`
  display: flex;
  justify-content: space-between;
  grid-template-columns: repeat(${(props) => props.columns}, 1fr);
  align-items: center;
  cursor: pointer;
  transition: 0.3s ease-in-out;
  font-size: 0.9rem;
  font-family: ThirdFont-regular;
  opacity: 1;

  &:hover {
    opacity: 0.8;
    background-color: #ffffff5e;
  }

  background-color: #ffffff1a;
  border: 1px solid var(--black);
  padding: 0 1rem;
  color: var(--black);

  &.selected {
    opacity: 1;
    background-color: #ffffff83;
    color: var(--black);
    border: 1px solid var(--accent);
  }

  &:active {
    transform: scale(0.99);
    transition: 0.3s;
    opacity: 0.5;
  }
`

const TableCell = styled.div`
  padding: 0.75rem 0;
  text-align: center;
  white-space: nowrap;
`

function processCell(row, cell) {
  switch (cell) {
    case "unitName":
      return row[cell]
    case "price":
      return poundFormatter.format(row["price"])
    case "unitType":
      return row[cell]
        .split(" ")
        .filter((txt) => txt !== "TYPE")
        .join("")
        .replace("1-STUDIO", "1-ST")
    case "aspect":
      return row[cell].replaceAll("c", "")
    case "beds":
      return row[cell] === 0 ? "Studio" : row[cell]
    case "baths":
      return row[cell] === 0 ? 1 : row[cell]
    case "floor":
      return row[cell] === "0" ? "GF" : row[cell]
    default:
      return row[cell]
  }
}
